import UpdateContact from "./updateContact";
import { Modal } from "../../../components/others/Modal/index";

type TProps = {
  toggleModal: boolean;
  urlTittle?: string;
  onClose: Function
};

const UpdateContactModal = ({ toggleModal, urlTittle, onClose }: TProps) => {
  const styles = "text-2xl text-red-500 font-bold";
  return (
    <>
      <Modal
        show={toggleModal}
        modalTitle={`Editar Información del Contacto`}
        titleStyle={styles}
        onClose={() => onClose()}
        urlTittle={urlTittle}
      >
        <UpdateContact handleClose={() => onClose()}/>
      </Modal>
    </>
  );
};

export default UpdateContactModal;
